import axios from 'axios';
import { Message } from 'element-ui';
import BUS from '@/utils/bus.utils';

let controle = 0;
let mostrar = false;
const aumentar = () => {
    controle++;
    if (!mostrar) {
        mostrar = true;
        BUS.$emit('loading:show');
    }
};

const diminuir = () => {
    controle--;
    if (controle <= 0) {
        controle = 0;
        if (mostrar) {
            mostrar = false;
            BUS.$emit('loading:hide');
        }
    }
};

const service = axios.create({
    baseURL: process.env.VUE_APP_ANALISE_PRADA_URL,
    timeout: 300000,
    withCredentials: true
});

service.interceptors.request.use((request) => {
    if (!request.hideLoading) {
        aumentar();
    }

    return request;
}, (error) => {
    diminuir();
    return Promise.reject(error);
});

service.interceptors.response.use(
    (response) => {
        diminuir();
        return response;
    },
    (error) => {
        diminuir();
        const data = error?.response?.data;

        if (!data || !data.message) {
            return Promise.reject(error);
        }
        Message({
            showClose: true,
            message: data.message,
            type: 'error',
            duration: 10000,
            dangerouslyUseHTMLString: true,
        })
        return Promise.reject(data);
    }
);

export default service;
